import { CHECK_USER_EXISTS } from '../constants/apiUrls/apiUrls';
import { validateEmailAddress } from '../services/EmailServices';

import callApi from './callApi';

export const isValidEmailInput = (email) =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

const hasInvalidEmailSpecialCharacters = (email) => {
  const localPart = email.split('@')[0];

  return /[ `!#$%^&*()+=[\]{};':"\\|,<>/?~]/.test(localPart);
};

export const validateEmailOnTempted = async (email) => {
  const trimmedEmail = email.trim();
  if (
    !isValidEmailInput(trimmedEmail) ||
    hasInvalidEmailSpecialCharacters(trimmedEmail)
  ) {
    return 'Invalid email address';
  }

  const { data } = await validateEmailAddress({ email: trimmedEmail });

  if (!data.data.available) {
    return 'Email address already in use';
  }

  return '';
};

export const validateEmailOnNakedNews = async (email) => {
  try {
    let URL = CHECK_USER_EXISTS;
    URL = URL.replace('{userEmailID}', `${email}`);
    const res = await callApi(URL);

    return res.data.status !== 'NOT_OK';
  } catch (err) {

    return false;
  }
};
